module.exports = __webpack_public_path__ + "static/media/algorithm_1.f3611e9c.svg";